import React from "react";
import {
  DialogContent,
  Card,
  TableContainer,
  Table,
  TableHead,
  TableBody,
} from "@material-ui/core";
import Colors from "shared/color";
import TableBodyCell from "components/table/TableBodyCell";


const RazorpayPayemntFailure = ({ data }) => {
  return (
    <DialogContent
      dividers={false}
      style={{
        backgroundColor: Colors["lighterPurple"],
        fontSize: "0.8125rem",
      }}
    >
      <div
        className="flex-spacing"
        style={{ margin: "1rem 0px", minWidth: "63vw" }}
      >
        {data && data.length ? (
          <Card>
            <TableContainer className="common_X_scroll">
              <Table
                size="small"
                aria-label="simple table"
                style={{ width: "100.1%" }}
              >
                <TableHead style={{textTransform:"capitalize"}}>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>id</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Method</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Bank</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Wallet</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Status</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Error Reason</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Error Description</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Error Code</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Error Step</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Error Source</span>
                  </TableBodyCell>
                </TableHead>
                {data.map((data) => (
                  <TableBody>
                    <TableBodyCell className="common_table_content">{data["id"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["status"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["method"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["bank"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["wallet"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["error_reason"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["error_description"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["error_code"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["error_step"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["error_source "]}</TableBodyCell>
                  </TableBody>
                ))}
              </Table>
            </TableContainer>
          </Card>
        ) : (
          "No payment details to show"
        )}
      </div>
    </DialogContent>
  );
};

export default RazorpayPayemntFailure;
